/**
 * Accordion (FAQ + generic). Idempotent: kan bij elke page-mount veilig
 * opnieuw aangeroepen worden zonder dubbele listeners.
 *
 * Hooks: [data-faq-item] / [data-faq-toggle] (Contact FAQ) en de generieke
 * variant [data-accordion-item] / [data-accordion-toggle] (bv. About Services).
 * "Sluit de andere items" wordt gescoped naar de dichtstbijzijnde
 * [data-accordion] container, of valt terug op de hele root.
 */
const ITEM_SELECTOR = '[data-faq-item], [data-accordion-item]';
const TOGGLE_SELECTOR = '[data-faq-toggle], [data-accordion-toggle]';

export default function initFaq(root = document) {
    const items = root.querySelectorAll(ITEM_SELECTOR);
    if (!items.length) return;

    items.forEach((item) => {
        if (item.dataset.faqBound === '1') return;
        item.dataset.faqBound = '1';

        const toggle = item.querySelector(TOGGLE_SELECTOR);
        if (!toggle) return;

        toggle.addEventListener('click', () => {
            const isOpen = item.getAttribute('data-open') === 'true';
            const scope = item.closest('[data-accordion]') || root;

            scope.querySelectorAll(ITEM_SELECTOR).forEach((other) => {
                other.setAttribute('data-open', 'false');
                other.querySelector(TOGGLE_SELECTOR)?.setAttribute('aria-expanded', 'false');
            });

            item.setAttribute('data-open', String(!isOpen));
            toggle.setAttribute('aria-expanded', String(!isOpen));
        });
    });
}
